var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 115.589,
    height: 123.999,
    viewBox: "0 0 115.589 123.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27aae1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b3976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.275,
    y1: 0.754,
    x2: 0.615,
    y2: 0.394,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b3976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27aae1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.085,
    y1: 0.115,
    x2: 0.682,
    y2: 0.936,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.498,
    y1: 0.721,
    x2: 0.52,
    y2: 4.341,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.513,
    y1: 2.095,
    x2: 0.5,
    y2: -0.01,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.498,
    y1: 0.115,
    x2: 0.502,
    y2: 1.87,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.497,
    y1: -0.537,
    x2: 0.504,
    y2: 1.811,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: 0.073,
    y1: 0.378,
    x2: 0.948,
    y2: 0.844,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-100 -9418.996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.335,867.328a10.861,10.861,0,0,1-2.8,1.088,12.843,12.843,0,0,1-2.971.348,9,9,0,0,1-3.308-.588,7.735,7.735,0,0,1-2.6-1.654,7.424,7.424,0,0,1-1.708-2.557,8.632,8.632,0,0,1-.609-3.3,8.307,8.307,0,0,1,.642-3.319,7.479,7.479,0,0,1,1.774-2.546,8.2,8.2,0,0,1,2.633-1.643,8.82,8.82,0,0,1,3.243-.588,9.386,9.386,0,0,1,2.927.457,6.268,6.268,0,0,1,2.514,1.567l-1.371,1.436a5.252,5.252,0,0,0-1.9-1.306,6.028,6.028,0,0,0-2.3-.457,6.247,6.247,0,0,0-2.459.479,5.95,5.95,0,0,0-3.275,3.352,7.222,7.222,0,0,0,0,5.115,6.119,6.119,0,0,0,1.306,2.035,5.851,5.851,0,0,0,2.013,1.339,6.8,6.8,0,0,0,2.59.479,9,9,0,0,0,1.959-.228,7.807,7.807,0,0,0,1.872-.664v-4.723H289.96v-1.7h5.376Z",
    transform: "translate(-181.341 8674.23)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.571,854.732h1.719l6.551,15.409h-2.133l-1.567-3.787h-7.7l-1.589,3.787h-2.068Zm.827,2.351h-.043l-3.2,7.574h6.29Z",
    transform: "translate(-283.212 8672.463)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.1,854.732h1.828v13.711h7.052v1.7H536.1Z",
    transform: "translate(-389.896 8672.463)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.1,854.732h9.685v1.7h-7.857v4.831h7.334v1.7h-7.334v5.484h8.248v1.7H632.1Z",
    transform: "translate(-468.485 8672.463)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.259,854.732h2.307l8.923,12.8h.044v-12.8h1.828v15.409h-2.307l-8.923-12.8h-.044v12.8h-1.828Z",
    transform: "translate(-556.208 8672.463)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.02,855.684a2.691,2.691,0,0,0-1.219-1.077,3.883,3.883,0,0,0-1.589-.337,4.774,4.774,0,0,0-1.2.152,3.562,3.562,0,0,0-1.055.457,2.287,2.287,0,0,0-.751.805,2.35,2.35,0,0,0-.283,1.175,2.446,2.446,0,0,0,.163.925,1.942,1.942,0,0,0,.533.729,3.953,3.953,0,0,0,1,.609,13.732,13.732,0,0,0,1.545.566q.892.283,1.73.61a5.822,5.822,0,0,1,1.48.827,3.676,3.676,0,0,1,1.023,1.252,4.27,4.27,0,0,1-1.284,5.289,5.24,5.24,0,0,1-1.73.827,7.539,7.539,0,0,1-2.024.272,7.715,7.715,0,0,1-1.349-.12,6.477,6.477,0,0,1-1.295-.37,5.233,5.233,0,0,1-1.164-.653,3.932,3.932,0,0,1-.936-.99l1.567-1.284a3.221,3.221,0,0,0,1.393,1.284,4.264,4.264,0,0,0,1.894.435,4.217,4.217,0,0,0,1.186-.174,3.591,3.591,0,0,0,1.077-.511,2.792,2.792,0,0,0,.784-.838,2.175,2.175,0,0,0,.3-1.154,2.46,2.46,0,0,0-.239-1.164,2.145,2.145,0,0,0-.74-.772,5.712,5.712,0,0,0-1.262-.588l-1.785-.609a11.271,11.271,0,0,1-1.523-.6,4.669,4.669,0,0,1-1.208-.827,3.532,3.532,0,0,1-.805-1.176,4.157,4.157,0,0,1-.294-1.643,3.966,3.966,0,0,1,1.61-3.319,5.341,5.341,0,0,1,1.676-.838,7.1,7.1,0,0,1,4.342.12,4.668,4.668,0,0,1,1.926,1.4Z",
    transform: "translate(-657.194 8674.23)",
    fill: "#022e63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.255,488.042a9.938,9.938,0,0,1-.912.7c.183-.185,10.1-10.363-4.433-29.242-12.678-19.388-.254-32.5,4-36.172-3.149,3.252-13.465,17.212.038,33.562C443.851,471.3,435.754,484.942,433.255,488.042Z",
    transform: "translate(-296.784 9025.627)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.958,483.367c2.5-3.1,10.6-16.744-1.3-31.152-13.5-16.35-3.187-30.31-.038-33.562.716-.617,1.2-.967,1.3-1.036-.537.406-12.471,9.714-.869,28.346C460.259,468.787,449.35,480.507,445.958,483.367Z",
    transform: "translate(-309.487 9030.301)",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.298 9467.594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M531.621,614.939q-2.19.15-4.407.151a37.489,37.489,0,0,1-13.412-2.327,32.524,32.524,0,0,1-3.6-1.609c.069-.611.116-1.237.145-1.877a32.034,32.034,0,0,0-1.179-9.388c-.187-.682-.386-1.378-.615-2.08a1.745,1.745,0,0,0-.054-.183c-.076-.232-.16-.464-.241-.7-.172-.5-.359-1-.551-1.505a46.456,46.456,0,0,0-1.9-4.293c-.18-.359-.364-.709-.564-1.068l-.145-.239-.448-.758c-.325-.562-.657-1.173-1.021-1.87-.034-.063-.062-.12-.1-.181h4.9a20.422,20.422,0,0,0,.785,2.809c.022.071.042.141.069.212a19.483,19.483,0,0,0,1.848,3.772,17.516,17.516,0,0,0,1.186,1.652q.413.528.869,1.012a17.847,17.847,0,0,0,6.089,4.237,19,19,0,0,0,6.23,1.458c-.024.334-.036.671-.036,1.01A14.313,14.313,0,0,0,531.621,614.939Z",
    transform: "translate(-503.529 -575.961)",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.231,526.1v22.247a14.334,14.334,0,0,0-13.149-9.36v-.02H618.339V526.1Z",
    transform: "translate(-597.516 -526.098)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.282,606.508v10.809c-.158.083-.315.167-.473.247a48.9,48.9,0,0,1-12.144,4.4,63.034,63.034,0,0,1-9,1.277,14.313,14.313,0,0,1-6.15-11.767c0-.339.013-.676.036-1.01.559.04,1.126.06,1.707.06a25.509,25.509,0,0,0,7.71-1.026,28.725,28.725,0,0,0,5.171-2.093V597.148A14.334,14.334,0,0,1,652.282,606.508Z",
    transform: "translate(-602.567 -584.262)",
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M531.273,323.5c3.261-3.439,13.224-17.275-.14-33.455-11.923-14.437-3.772-28.106-1.29-31.172a11.16,11.16,0,0,1,.936-.724c-.292.3-6.892,7.286-1.079,20.233q.558,1.243,1.275,2.561a48.285,48.285,0,0,0,4.244,6.442q.454.691.865,1.373a37.045,37.045,0,0,1,1.944,3.66C545.706,308.96,535.191,320.11,531.273,323.5Z",
    transform: "translate(-380.656 9160.848)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.7,326.765c-.5.43-.887.734-1.121.91a16.593,16.593,0,0,0,5.193-8.666,18.132,18.132,0,0,0,.479-3.546,19.684,19.684,0,0,0-.178-3.544,22.891,22.891,0,0,0-.771-3.546,29.855,29.855,0,0,0-1.676-4.431,36.385,36.385,0,0,0-1.879-3.544c-.167-.294-.345-.586-.531-.887q-1.208-1.82-2.205-3.546c-.709-1.213-1.339-2.4-1.888-3.544-8.793-18.122.094-27.695,3.149-30.285-2.483,3.065-10.634,16.735,1.29,31.172C535.923,309.489,525.961,323.326,522.7,326.765Z",
    transform: "translate(-372.082 9157.58)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.955,381.276l-12.3,1.756-.1.014-.007,0c-2.88-11.515-15.69-10.175-20.4-9.261q-.411-.683-.865-1.373a48.309,48.309,0,0,1-4.244-6.442q-.718-1.317-1.275-2.561c19.557-3.932,29.376,1.117,34.295,6.838l.163.192A20.8,20.8,0,0,1,590.955,381.276Z",
    transform: "translate(-402.715 9075.818)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.558,432.662H474.7l2.135-3.544h8.836C486.219,430.261,486.849,431.449,487.558,432.662Z",
    transform: "translate(-339.63 9020.887)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.064,556.158a18.131,18.131,0,0,1-.479,3.546H489.321l-2.082-3.546Z",
    transform: "translate(-349.896 8916.887)",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.55,475.642H467.829l.537-3.544h16.3A36.374,36.374,0,0,1,486.55,475.642Z",
    transform: "translate(-334.006 8985.701)",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.289,517.614H472.423l-1.794-3.546h19.889A22.878,22.878,0,0,1,491.289,517.614Z",
    transform: "translate(-336.298 8951.346)",
    fill: "url(#l)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.544 9507.307)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.422,
    cy: 1.422,
    r: 1.422,
    transform: "translate(6.635)",
    fill: "#2b3976"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37,
    cy: 2.37,
    r: 2.37,
    transform: "translate(0 3.791)",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 1.422,
    cy: 1.422,
    r: 1.422,
    transform: "translate(130.271 9443.033)",
    fill: "#27aae1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.37,
    cy: 2.37,
    r: 2.37,
    transform: "translate(127.428 9436.396)",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.9,418.435l-12.3,1.756-.1.015a15.49,15.49,0,0,1,7.5-12.8l.163.192A20.8,20.8,0,0,1,711.9,418.435Z",
    transform: "translate(-523.66 9038.658)",
    fill: "url(#o)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.8092fdf05b72385260a9cdefcfeb3574.svg";
export { ForwardRef as ReactComponent };